export default __webpack_public_path__ + "static/media/2.0f8a79af.png";